import React from "react";
import { Col, Typography } from "antd";
import { ReactComponent as EmptyIcon } from "../../../assets/icons/emptyTable.svg";

const { Text } = Typography;

const EmptyTable = ({mainText}) => {
  return (
    <>
      <Col
        style={{
          height: "300px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          // gap: "16px",
        }}
      >
        <EmptyIcon style={{ marginBottom: "24px" }} />
        <Text
          style={{
            display: "block",
            color: "#0a243f",
            fontSize: "20px",
            fontWeight: 500,
            marginBottom: "10px",
          }}
        >
          {mainText}
        </Text>      
      </Col>
    </>
  );
};

export default EmptyTable;
